import { useNavigate } from 'react-router-dom';
import { signOut } from "firebase/auth";
import { auth } from '@/features/auth/firebase';

export function useLogout() {
  const navigate = useNavigate();

  return async function logout() {
    try {
      await signOut(auth);
      navigate('/');
    } catch (err) {
      console.error(err);
    }
  };
}
